import React from 'react';
import Skeleton from 'react-loading-skeleton';
import _ from 'lodash';
import lib from 'helpers/lib';

const CardVolume = ({ data }) => {
  return (
    <div className="col-sm-12 col-md-6 col-lg-3 mb-4">
      <div className="card h-100">
        <div className="card border-left-primary shadow h-100 py-2">
          <div className="card-body">
            <div className="row no-gutters align-items-center">
              <div className="col mr-2">
                <div className="text-md font-weight-bold text-primary text-uppercase mb-2">
                  Volume
                </div>

                <div className="h5 mb-0 font-weight-bold text-gray-800">
                  <div className="row">
                    <div className="col-4">Meta</div>
                    <div className="col-8">
                      {_.isNil(data.valorMeta) ? (
                        <Skeleton count={1} width={'100%'} height={20} />
                      ) : data.valorMeta === 0 ? (
                        `${data.valorMeta} kg`
                      ) : (
                        `${data.valorMeta.toFixed(3).substring(0, String(data?.valorMeta).length - 3)} kg`
                      )}
                    </div>

                    <div className="col-4">Pedido</div>
                    <div className="col-8">
                      {_.isNil(data.valorPedido) ? (
                        <Skeleton count={1} width={'100%'} height={20} />
                      ) : data.valorPedido === 0 ? (
                        `${data.valorPedido} kg`
                      ) : (
                        `${data.valorPedido.toFixed(3).substring(0, String(data?.valorPedido).length - 4)} kg`
                      )}
                    </div>

                    <div className="col-4">Faturado</div>
                    <div className="col-8">
                      {_.isNil(data.valorFaturado) ? (
                        <Skeleton count={1} width={'100%'} height={20} />
                      ) : data.valorFaturado === 0 ? (
                        `${data.valorFaturado} kg`
                      ) : (
                        `${data.valorFaturado.toFixed(3).substring(0, String(data?.valorFaturado).length - 4)} kg`
                      )}
                    </div>

                    <div className="col-4">GAP</div>
                    <div className="col-8">
                      {_.isNil(data.valorGap) ? (
                        <Skeleton count={1} width={'100%'} height={20} />
                      ) : (
                        `${data.valorGap} kg  | ${data.porcentagemGap}% Atg.`
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardVolume;
